export class CartAttributes
{
  public cartDetailVo: CartDetailAttributes[];
  public cartId: number;
  public createdDate: any;
  public updatedDate: any;
  public userId: number;

}

export class CartDetailAttributes {
  public SNo : number;
  public cartDetailDomainId : number;
  public createdDate: any;
  public dealerId: number;
  public OrderType: number;
  public UserName: any;
  public DealUserName: any;
  public distributorId: number;
  public ProductCode: any;
  public Qty: number;
  public updatedDate: any;
  public deleteFlag: boolean;
  public isorder: boolean;
}

export class Orderbooking
{
public price: number;
public orderType: string;
public itemId: number;
public TotalPrice: number;
public NetPrice: number;
  public totalDiscountedAmount: number;
  public qty: number;
  public orderNumber: string;
  public salesOrderId: number;
  public salesOrderNumber: string;
  public refSalesOrderNumber:string;
  public dealerId: number;
  public distributorId: number;
  public totalQty:number = 0;
  public TotalQty:number = 0;
  public totalAmount: number = 0;
  public dealerName:string;
  public distributorName:string;
  public fieldOfficerName:string;
  public fieldSalesOfficerId:number;
  public discountId:number;
  public createdByDealer:boolean;
  public distributorRemarks:string;
  public salesOrderCreatedDate:string;
  public skuCount:number;
  public status:string;
  public Status:string;
  public sapInvoiceRef:string;
  public createDate:string;
  public dealerFirstName:string;
  public saleOrderStatus:any;
  public statusFlag:boolean;
  public netValue: number = 0;

}

export class saleDetails
{
  public itemCode:number;
  public itemId:number;
  public price:number;
  public netValue:number;
  public transactionalProductQty:number;
  public bookedQty:number;
  public cashDiscountId:number;
  public activationDiscountPercentage:number;
  public cashDiscountPercentage:number;
  public priceGroupDiscountPercentage:number;
  public qty:number;
  public tradeDiscountPercentage:number;
  public totalDiscountedAmount:number;
  public activationDiscountPrice:number;
  public cashDiscountPrice:number;
  public discountedPrice:number;
  public priceGroupDiscountPrice:number;
  public tradeDiscountPrice:number;
  public discountPercentage:number;
  public dealerFirstName:string;
  public sapInvoiceRef:string;
  public batchWiseBookingQtyVos:any[];
  public activationDiscountId:number;
  public tradeDiscountId:number;
  public priceGroupDiscountId:number;
  public deleteYN:string;
}

export class salesOrderAndOrderDetails
{
  public salesOrderDetailsVO: any;
  public salesOrderVO:any;
  public salesOrderId: number;
  public itemId:number;
  public batchWiseBookingQtyVos:any[];
}

export class BatchDetails {
  public batchWiseBookingQtyVos: any[];
}


